import React from 'react';
import PropTypes from 'prop-types';

import {onAdsContextInit, setTargeting} from '../../services/targeting';
import {MesoAdsContext} from '../MesoAdsContext/MesoAdsContext';
import {shouldAdsRefresh} from "../../utils/need-ads-refresh";
import isEqual from 'lodash.isequal';

export class MesoAdsContextWithSearchParams extends React.Component {

    static getDerivedStateFromProps(props, state) {
        const newState = {};
        if (props.gaiaId !== state.gaiaId) {
            newState.gaiaId = props.gaiaId;
        }

        if (!isEqual(props.searchParams, state.latestSearchParams)) {
            newState.staleSearchParams = state.latestSearchParams || {};
            newState.latestSearchParams = props.searchParams || {};
        }

        if (Object.keys(newState).length) {
            newState.needsUpdate = true;
            return newState;
        }

        return null;
    }

    constructor(props) {
        super(props);
        this.state = {
            isBrowser: typeof window !== 'undefined'
        };
    }

    componentDidMount() {
        if (this.state.isBrowser) {
            const {brandId, locale, havId, gaiaId} = this.props;
            onAdsContextInit({brandId, locale, havId, gaiaId});

            const {latestSearchParams={}} = this.state
            setTargeting({gaiaId, targetingParams: latestSearchParams});
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.isBrowser) {
            const {staleSearchParams, gaiaId, needsUpdate, latestSearchParams={}} = this.state
            if (
                needsUpdate && 
                (prevProps.gaiaId !== gaiaId || shouldAdsRefresh(staleSearchParams.params, latestSearchParams.params))
            ) {
                this.setState({needsUpdate:false});
                setTargeting({gaiaId, targetingParams: latestSearchParams});
            }
        }
    }

    render() {
        return <MesoAdsContext {...this.props} ></MesoAdsContext>
    }
}

MesoAdsContextWithSearchParams.defaultProps = {
    searchParams: {}
};

MesoAdsContextWithSearchParams.propTypes = {
    ...MesoAdsContext.propTypes,
    gaiaId: PropTypes.string.isRequired,
    // Represent data from search filters
    searchParams: PropTypes.shape({
        pathname: PropTypes.string,
        params: PropTypes.shape({
            q: PropTypes.string,
            zoom: PropTypes.number,
            neLat: PropTypes.number,
            swLat: PropTypes.number,
            swLong: PropTypes.number
        }),
        prevParams: PropTypes.shape({
            q: PropTypes.string,
            zoom: PropTypes.number,
            neLat: PropTypes.number,
            swLat: PropTypes.number,
            swLong: PropTypes.number
        })

    }).isRequired
};
